export enum FiChatConversationType {
    OneToOne = 0,
    Group = 1,
    Forward = 2,
}
